module.exports = __webpack_public_path__ + "img/dc.5524ba66.png";